import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	input: {
		height: 31,
		maxWidth: 140,
	},
	label: {
		marginTop: 10,
	},
	linkActions: {
		marginTop: 4,
	},
	linkText: {
		maxWidth: 200,
	},
});
